import React from "react";
import { Box, Typography, Button } from "@mui/material";


export default function SessionExpired() {


    return (
        <Box
            sx={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f5f5f5",
                textAlign: "center",
                px: 2
            }}
        >
            <Typography variant="h1" color="error" fontWeight="bold">
                404
            </Typography>

            <Typography variant="h1" sx={{ mt: 1 }}>
                Session Expired
            </Typography>

            <Typography sx={{ mt: 1, mb: 3, color: "text.secondary" }}>
                Your session has expired for security reasons.
                Please reopen the link or request a new access.
            </Typography>

        </Box>
    );
}
